import { TableCell } from '@material-ui/core'
import * as React from 'react'
import { connect } from 'react-redux'

import { locale } from '../../locale'
import { getDeviceIds } from '../../state/DeviceById/selectors'
import { Category, State } from '../../types'
import DeviceListItemContainer from './DeviceListItemContainer'

type Props = {
  deviceIds: string[]
  category: Category
}
const arrayChunk = <T,>(arr: T[], size: number): T[][] =>
  Array.from({ length: Math.ceil(arr.length / size) }, (v, i) =>
    arr.slice(i * size, i * size + size),
  )

function DeviceListChunk(props: Props) {
  return (
    <DeviceList category={props.category} deviceIds={props.deviceIds} />

    // <>
    //   {arrayChunk(props.deviceIds, 10).map((deviceIds, i) => (
    //     <DeviceList
    //       key={`chunk-${i}`}
    //       category={props.category}
    //       deviceIds={deviceIds}
    //     />
    //   ))}
    // </>
  )
}

function DeviceList(props: Props) {
  return (
    <table style={{ width: '100%' }}>
      <thead>
        <tr>
          <TableCell>{locale.device.id}</TableCell>
          <TableCell>{locale.device.label}</TableCell>
          <TableCell>{locale.device.memo}</TableCell>
          <TableCell>{locale.device.clients}</TableCell>
          {props.category === 'yuatsu' && (
            <TableCell>電池電圧[V](最終更新)</TableCell>
          )}
          <TableCell />
        </tr>
      </thead>
      <tbody>
        {props.deviceIds.map((deviceId, i) => (
          <DeviceListItemContainer
            deviceId={deviceId}
            key={`row-${deviceId}_${i}`}
          />
        ))}
      </tbody>
    </table>
  )
}

const DeviceListMemo = (props: Props) => {
  const child = React.useMemo(
    () => <DeviceListChunk {...props} />,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [props.deviceIds.length],
  )

  return <>{child}</>
}

type OProps = { category: Category }
const conn = connect(
  (state: State, op: OProps) => ({
    deviceIds: getDeviceIds(state, op.category),
    category: op.category,
  }),
  {},
)
const DeviceListContainer = conn(DeviceListMemo)

export default DeviceListContainer
